














import { Component, Prop, Vue, Inject } from 'vue-property-decorator';

@Component
export default class ProductImageCarousel extends Vue {
    @Prop({ required: true })
    public images!: string[];

    public currentIndex: number = 0;

    get canSwtich (): boolean {
        return this.images.length > 1;
    }

    public goToIndex (index: number) {
        this.currentIndex = index;
    }
}
